

export default function BookingCardText() {
  
  return (
<div>
    
    Please enter your preferred date / time choices by clicking on the calender tool below.
    </div>

   )
}